import { useEffect, useState } from 'react';
import { api, type LinhaExtrato } from '../api';
import { voltar } from '../rota';
import { Moeda, OrbitaAberta } from '../orbita';
import { Carregando } from '../../../compartilhado/Espera';
import { MESES, diaCurto } from '../formato';

/**
 * A tela 6 do mockup: ganho é bolinha laranja e +N em laranja; saída é aro
 * vazio e −N apagado; expiração é aro tracejado. Agrupado por mês, e o estado
 * vazio é a órbita aberta esperando a primeira moeda (tela 6b).
 */

const ROTULO: Record<string, string> = {
  acumulo: 'compra na loja',
  resgate: 'troca por prêmio',
  bonus: 'bônus',
  ajuste: 'ajuste da loja',
  estorno: 'estorno',
  expiracao: 'moedas expiradas',
};

function Icone({ linha }: { linha: LinhaExtrato }) {
  if (linha.tipo === 'expiracao') return <span className="ex-aro tracejado" />;
  if (linha.moedas >= 0) return <Moeda />;
  return <span className="ex-aro" />;
}

export function Extrato({ aoFalhar }: { aoFalhar: (e: unknown) => void }) {
  const [linhas, setLinhas] = useState<LinhaExtrato[] | null>(null);
  const [erro, setErro] = useState('');

  useEffect(() => {
    api
      .extrato()
      .then((d) => setLinhas(d.linhas))
      .catch((e) => {
        setErro('não consegui carregar o extrato');
        aoFalhar(e);
      });
  }, [aoFalhar]);

  if (erro) return <div className="erro-tela">{erro}</div>;
  /* Primeira abertura: o extrato ainda não chegou, não há linha para cobrir. */
  if (!linhas)
    return (
      <div className="espera-tela">
        <Carregando />
      </div>
    );

  const grupos: { mes: string; linhas: LinhaExtrato[] }[] = [];
  for (const l of linhas) {
    const d = new Date(l.criadoEm);
    const mes = `${MESES[d.getMonth()]}${d.getFullYear() !== new Date().getFullYear() ? ` ${d.getFullYear()}` : ''}`;
    const grupo = grupos[grupos.length - 1];
    if (grupo && grupo.mes === mes) grupo.linhas.push(l);
    else grupos.push({ mes, linhas: [l] });
  }

  return (
    <div className="tela ex">
      <header className="ex-topo">
        <button className="volta" onClick={voltar} aria-label="voltar">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path d="M10 3 5 8l5 5" fill="none" stroke="var(--ink)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <h1 className="titulo-tela sem-margem">extrato</h1>
      </header>

      {linhas.length === 0 ? (
        <div className="ex-vazio">
          <OrbitaAberta frac={0.72} />
          <p>sua primeira moeda aparece aqui</p>
        </div>
      ) : (
        grupos.map((g) => (
          <section key={g.mes}>
            <div className="ex-mes">{g.mes}</div>
            {g.linhas.map((l, i) => {
              const quando = diaCurto(l.criadoEm);
              return (
                <div key={i} className="ex-linha">
                  <span className="ex-icone">
                    <Icone linha={l} />
                  </span>
                  <span className="ex-meio">
                    <span className="ex-titulo">{ROTULO[l.tipo] ?? l.tipo}</span>
                    <span className="ex-sub">
                      {[
                        /* O que ela trocou (F4): "Picolé de limão" na linha do
                           resgate — no app, no balcão ou no caixa. */
                        l.premio,
                        l.loja,
                        quando,
                        /* A carência da loja (F1): a moeda está aqui, só espera. */
                        l.disponivelEm ? `disponível em ${diaCurto(l.disponivelEm)}` : null,
                      ]
                        .filter(Boolean)
                        .join(' · ')}
                    </span>
                  </span>
                  <span className={l.moedas >= 0 ? 'ex-valor ganho' : 'ex-valor'}>
                    {l.moedas >= 0 ? `+${l.moedas}` : l.moedas}
                  </span>
                </div>
              );
            })}
          </section>
        ))
      )}
    </div>
  );
}
